// import { Text } from '@stacks/ui';
import { LedgerError, ResponseVersion } from '@zondax/ledger-stacks';

interface CommonLedgerInlineWarningsProps {
  chain: 'Stacks' | 'Bitcoin';
  latestDeviceResponse: any | null;
  outdatedLedgerAppWarning?: boolean;
}

function isStacksLedgerAppClosed(response: ResponseVersion) {
  const anotherUnknownErrorCodeMeaningAppClosed = 28161;

  return (
    response.returnCode === LedgerError.AppDoesNotSeemToBeOpen ||
    response.returnCode === anotherUnknownErrorCodeMeaningAppClosed
  );
}

export const CommonLedgerDeviceInlineWarnings = ({
  chain,
  latestDeviceResponse,
  outdatedLedgerAppWarning = false,
}: CommonLedgerInlineWarningsProps) => {
  if (!latestDeviceResponse) return null;

  if (outdatedLedgerAppWarning) {
    return (
      <div style={{ color: 'red' }}>
        Latest version of {chain} app required
        {/* <Text as="a" textDecoration="underline" href="ledgerlive://manager"> */}
        Update on Ledger Live to continue
        {/* </Text> */}
      </div>
    );
  }
  if (latestDeviceResponse.deviceLocked)
    return (
      <div style={{ color: 'red' }}>
        Your Ledger is locked. Unlock it and open the {chain} app to continue.
      </div>
    );
  if (isStacksLedgerAppClosed(latestDeviceResponse))
    return (
      <div style={{ color: 'red' }}>
        The {chain} app appears to be closed on Ledger. Open it to continue.
      </div>
    );

  return null;
};
